<template lang="pug">
  .classifier-form
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      :hideDeleteButton="false"
      :showSaveButton="false"
    )
      div(slot="header" style="flex-grow:1")
        e-breadcrumbs
        h1.modal__title {{formTitle}}
          .edit-select
            select.select(@change="changeEditSelect")
              option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // ОБЩИЕ СВЕДЕНИЯ
          .body-flex(v-show="tabView === 'tab1'")
            .modal__row
              .modal__col
                e-form-group(
                  name="legal_entity_name"
                  inputType="input"
                  label="Наименование ЮЛ/ИП"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
                e-form-group(
                  name="activity_type"
                  inputType="input"
                  label="Вид деятельности в области обращения с ТКО и отходами после обработки ТКО"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
                e-form-group(
                  name="okpo"
                  inputType="input"
                  label="ОКПО"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
                e-form-group(
                  name="inn"
                  inputType="input"
                  label="ИНН"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
                e-form-group(
                  name="ogrn"
                  inputType="input"
                  label="ОГРН"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
                e-form-group(
                  name="oktmo"
                  inputType="input"
                  label="ОКТМО"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
                e-form-group(
                  name="fact_address"
                  inputType="input"
                  label="Фактический адрес ЮЛ/ИП"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
                e-form-group(
                  name="legal_address"
                  inputType="input"
                  label="Юридический адрес ЮЛ/ИП"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
              .modal__col
                e-form-group(
                  name="official"
                  inputType="input"
                  label="ФИО, уполномоченного предоставлять форму"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
                e-form-group(
                  name="position"
                  inputType="input"
                  label="Должность, уполномоченного предоставлять форму"
                  :model="fields"
                  tabView="tab1"
                  :required='true'
                  :disabled='true'
                )
                e-form-group(
                  name="email"
                  inputType="input"
                  label="E-mail"
                  :model="fields"
                  tabView="tab1"
                  validationRule="email"
                  :disabled='true'
                )
                e-form-group(
                  name="phone"
                  inputType="input"
                  label="Телефон"
                  :model="fields"
                  tabView="tab1"
                  :disabled='true'
                )
                e-form-group(
                  name="filling_date"
                  inputType="input"
                  label="Дата заполнения"
                  :model="fields"
                  tabView="tab1"
                  :disabled="true"
                )
          // Детали
          order-details(v-if="tabView === 'tab2'" )
</template>

<script>
import formBaseMixin from '@/components/form/form-base-mixin'
import { report } from '@/api/api-endpoints'
import OrderDetails from './components/order-details'

export default {
  components: {
    OrderDetails,
  },
  mixins: [formBaseMixin],
  data: () => {
    return {
      tabView: 'tab1',
      fields: {},
    }
  },
  computed: {
    tabs() {
      return [{ tab1: 'Общие сведения' }, { tab2: 'Отчетность' }]
    },
  },
  methods: {
    getItemEndpoint(route) {
      return report.order285ById(route.params.id)
    },
    changeEditSelect(event) {
      const val = this.tabs[event.target.selectedIndex]
      this.tabView = Object.keys(val)[0]
    },
    async getData() {
      await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getItemEndpoint(this.$route),
      })
    },
  },
  created() {
    this.getData()
  },
}
</script>
